import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import EssayLayout from "../components/EssayLayout";

export default function EssayPaid() {

  const { teacherId, moduleId, count } = useParams();

  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);

  const isReviewMode = queryParams.get("review") === "true";

  const [essays, setEssays] = useState([]);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);

  const [essayType, setEssayType] = useState(
    queryParams.get("type") || "model_papers"
  );

  const [subjectName, setSubjectName] = useState("");
  const [teacherName, setTeacherName] = useState("");

  const [submitted, setSubmitted] = useState(false);
  const [score, setScore] = useState(0);

  const [historyReviewMode, setHistoryReviewMode] =
    useState(false);

  const EXAM_TIME = 5 * 60;

  const [timeLeft, setTimeLeft] =
    useState(EXAM_TIME);

  const [submitting, setSubmitting] =
    useState(false);

  /* ================= REVIEW MODE ================= */

  useEffect(() => {

    if (!isReviewMode) return;

    const reviewData = JSON.parse(
      localStorage.getItem("review_essay_data")
    );

    if (!reviewData) return;

    setEssayType(
      reviewData.essayType || "model_papers"
    );

    setAnswers(reviewData.answers || {});
    setSubjectName(reviewData.subject_name || "");
    setTeacherName(reviewData.teacher_name || "");

    setScore(reviewData.marks || 0);

    setSubmitted(true);

    setHistoryReviewMode(true);

  }, [isReviewMode]);



  /* ================= TIMER ================= */

  useEffect(() => {

    if (
      submitted ||
      historyReviewMode
    )
      return;

    const timer = setInterval(() => {

      setTimeLeft(t => {

        if (t <= 1) {

          clearInterval(timer);

          handleSubmit();

          return 0;

        }

        return t - 1;

      });

    }, 1000);

    return () =>
      clearInterval(timer);

  }, [
    submitted,
    historyReviewMode
  ]);



  /* ================= FETCH ================= */

  useEffect(() => {

    if (
      !teacherId ||
      !moduleId
    )
      return;

    setLoading(true);

    const reviewData = JSON.parse(
      localStorage.getItem("review_essay_data")
    );

    const currentEssayType =
      isReviewMode
        ? reviewData?.essayType ||
          "model_papers"
        : essayType;

    fetch(
      `https://edunet.kmechengineering.com/root-engine1/api/essay-paid?teacher_id=${teacherId}&module_id=${moduleId}&essay_type=${currentEssayType}&limit=${count}`
    )

      .then(res => res.json())

      .then(data => {

        setEssays(
          data.essay_data || []
        );

        setSubjectName(
          data.subject_name || ""
        );

        setTeacherName(
          data.teacher_name || ""
        );

        if (
          isReviewMode &&
          reviewData
        ) {

          setAnswers(
            reviewData.answers || {}
          );

          setScore(
            reviewData.marks || 0
          );

          setSubmitted(true);

          setHistoryReviewMode(
            true
          );

        } else {

          setAnswers({});

        }

        setLoading(false);

      })

      .catch(err => {

        console.log(err);

        setLoading(false);

      });

  }, [
    teacherId,
    moduleId,
    count,
    essayType,
    isReviewMode
  ]);



  /* ================= SUBMIT ================= */

  const handleSubmit = async () => {

    if (submitting) return;

    setSubmitting(true);

    try {

      const user = JSON.parse(
        localStorage.getItem("user")
      );

      let guestToken =
        localStorage.getItem(
          "guest_token"
        );

      if (!guestToken) {

        guestToken =
          crypto.randomUUID();

        localStorage.setItem(
          "guest_token",
          guestToken
        );

      }

      const response =
        await fetch(
          "https://edunet.kmechengineering.com/root-engine1/api/essay-save",
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json"
            },
            body: JSON.stringify({

              user_id: user?.id,

              guest_token:
                guestToken,

              subject_id:
                essays[0]?.subject_id,

              module_id:
                moduleId,

              teacher_id:
                teacherId,

              type: "paid",

              essay_type:
                essayType,

              answers

            })
          }
        );

      const data =
        await response.json();

      if (data.status) {

        const reviewAnswers =
          {};

        if (
          Array.isArray(
            data.answers
          )
        ) {

          data.answers.forEach(
            item => {

              reviewAnswers[
                item.essay_id
              ] = item;

            }
          );

        }

        localStorage.setItem(
          "review_essay_data",
          JSON.stringify({

            answers:
              reviewAnswers,

            marks:
              data.marks,

            total_marks:
              data.total_marks,

            subject_name:
              subjectName,

            teacher_name:
              teacherName,

            essayType,

            teacherId,

            moduleId

          })
        );

        setScore(
          data.marks
        );

        setSubmitted(true);

      }

    } catch (err) {

      console.log(err);

    } finally {

      setSubmitting(false);

    }

  };

  /* ================= REVIEW ================= */

  const handleReview = () => {

    navigate(
      `/essay/paid/teacher/${teacherId}/${moduleId}/${count}?type=${essayType}&review=true`
    );

  };


  /* ================= RETRY ================= */

  const handleRetry = () => {

    setSubmitted(false);

    setAnswers({});

    setScore(0);

    setTimeLeft(EXAM_TIME);

  };


  /* ================= LOADING ================= */

  if (loading) {

    return (

      <div
        style={{
          color: "#fff",
          textAlign: "center",
          marginTop: "100px",
          fontSize: "22px",
          fontWeight: "bold"
        }}
      >

        Loading Essays...

      </div>

    );

  }


  /* ================= EMPTY ================= */

  if (essays.length === 0) {

    return (

      <div
        style={{
          color: "#fff",
          textAlign: "center",
          marginTop: "100px",
          fontSize: "22px",
          fontWeight: "bold"
        }}
      >

        No Essays Found

      </div>

    );

  }


  return (

    <EssayLayout
      title={`Paid ${essayType.toUpperCase()} Essay (${essays.length})`}
      subject={subjectName || "Subject"}
      teacher={teacherName || "Teacher"}
      questions={essays}
      timeLeft={timeLeft}
      historyReviewMode={historyReviewMode}
      answers={answers}
      submitted={submitted}
      submitting={submitting}
      score={score}
      showPremium={false}
      showContinue={false}
      essayType={essayType}
      setEssayType={setEssayType}

      onAnswer={(id, value) =>
        setAnswers(prev => ({
          ...prev,
          [id]: value
        }))
      }

      onSubmit={handleSubmit}

      onReview={handleReview}

      onRetry={handleRetry}
    />

  );

  }

